import React, { Component } from 'react'
import styled from 'styled-components'
import ReactSwipe from 'react-swipe'
import { media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme';

export default class Carousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            picture: '',
            isMobile: false,
            allPics: '',
            currentPic: ''
        }
    }

    componentDidMount = () => {
        this.detectMobile();
        this.setState({ allPics: this.props.pictures.length })
        this.markowski();
    }
    detectMobile = () => {
        const width = window.innerWidth
        const isMobile = width <= theme.grid.breakpoints.md

        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile })
        }
    }

    onPress = () => {
        this.props.parentCallback(false)
    }
    markowski = () => {
        
        this.setState({currentPic: this.reactSwipeEl.swipe.getPos() + 1})
    }

   


    render() {
        const {
            icons,
            image,
            pictures,
            parentCallback,
            start
        } = this.props
        const { picture, isMobile, currentPic } = this.state
        const opts = {
            width: '',
            height: ''
        }


        const swipeOptions = {
            continuous: false,
            startSlide: start,
            transitionEnd: this.markowski
        }

        let reactSwipeEl;

        return (
            <Wrapper innerRef={this.props.innerRef}>
                <ReactSwipe
                    className="carousel"
                    swipeOptions={swipeOptions}
                    ref={el => (this.reactSwipeEl = el)}
                >
                    {pictures.map((item, index) =>
                        <div style={{ display: 'flex', width: '100%' }} key={index}>
                            <Image picture={item.image.sourceUrl} >
                                <Close onClick={this.onPress} />
                            </Image>
                        </div>
                    )}
                </ReactSwipe>
                {isMobile === false &&
                    <ButtonWrapper>
                        <button onClick={() => this.reactSwipeEl.prev()}><ArrowPrev></ArrowPrev></button>
                        <button onClick={() => this.reactSwipeEl.next()}><ArrowNext></ArrowNext></button>
                    </ButtonWrapper>
                }
                {isMobile !== false &&
                    <SlideNo>
                        {currentPic + ' / ' + pictures.length}
                    </SlideNo>
                }
            </Wrapper>
        )
    }
}

//style
const Wrapper = styled.div`
margin: 20% auto;
width: 90%;

${media.lg`
width: 50%;
margin: 2% auto;
`}
`
const SlideNo = styled.div`
display: flex;
justify-content: space-evenly;
padding: 10px;
background-color: white;
width: initial;
`

const Image = styled.div`
background: url(${props => props.picture}) center / contain;
background-repeat: no-repeat;
height: 90vw;
width: 100%;
background-position: center;
background-color: white;

${media.lg`
height: 30vw;
background-color: initial;
`}
`

const ButtonWrapper = styled.div`
display: flex;
justify-content: space-evenly;
padding: 10px;
background-color: white;
width: initial;

&& button {
    position:relative;
    width:16%;
    padding-bottom:15%;
    background:none;
    border-radius:50%;
    border-style: none;
    -webkit-box-shadow: 6px 10px 22px 3px rgba(0,0,0,0.13);
-moz-box-shadow: 6px 10px 22px 3px rgba(0,0,0,0.13);
box-shadow: 6px 10px 22px 3px rgba(0,0,0,0.13);

${media.md`
background-color: rgba(255, 255, 255, 0.9);
width: 7%;
padding-bottom:7%;
margin: 0 10px;
`}
}

${media.md`
background: none;
justify-content: center;
`}
`
const ArrowNext = styled.div`
display: inline-block;
width: 15px;
height: 15px;
border-top: 2px solid #000;
border-right: 2px solid #000;
position:absolute;
top:50%; left:50%;
transform: translate(-50%, -50%) rotate(45deg);
margin:0;
border-color: #00994c;
`
const ArrowPrev = styled.div`
display: inline-block;
width: 15px;
height: 15px;
border-top: 2px solid #000;
border-right: 2px solid #000;
position:absolute;
top:50%; left:50%;
transform: translate(-50%, -50%) rotate(-135deg);
margin:0;
border-color: #00994c;
`

const Close = styled.div`
position: relative;
background-color: white;
border-radius:50%;
border-style: none;
float: right;
    right: 4%;
    top: 2%;
text-align: center;
width: 24px;
height: 24px;
cursor: pointer;
z-index: 1111;

&:after {
    display: inline-block;
    content: "\00d7"; 

}

`


// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductPage/carousel.js